import React from "react";
import "./EmojiPickerModal.scss";
import "../../../../components/ModalContent/ModalComponents.scss";
import EmojiPicker from "emoji-picker-react";

function EmojiPickerModal({ onSelectEmoji }) {
  return (
    <div className="emoji-picker-modal-content">
      <EmojiPicker
        onEmojiClick={(emojiObject) => {
          onSelectEmoji(emojiObject.emoji);
        }}
        width="100%"
        height="400px"
        previewConfig={{
          showPreview: false,
        }}
      />
    </div>
  );
}

export default EmojiPickerModal;
